export const useJsonLd = (
  id: string,
  data: MaybeRefOrGetter<Record<string, unknown> | null | undefined>,
  enabled: MaybeRefOrGetter<boolean> = true
) => {
  useHead(() => {
    const value = toValue(data)

    return {
      script:
        toValue(enabled) && value
          ? [
              {
                id,
                type: 'application/ld+json',
                innerHTML: JSON.stringify(value).replace(/</g, '\\u003c')
              }
            ]
          : []
    }
  })
}
